<template>
    <div>
        <b-link :to="{name:'basic-dataloghome'}" class="preTitlse" style="color: #5E8F23">{{preTitle}}</b-link>
        <b-button class="plusButtoxn mr-1 px-0 pt-0 pb-0">
            <b-link :to="{ name: 'basic-dataloghome'}">
                <b-img width="50px" 
                    src="@/assets/images/ganImage/icons/add.png"
                />
            </b-link>
        </b-button>
    </div>
</template>

<script>
import {BImg, BLink, BButton} from 'bootstrap-vue'
export default {
    props:{
        preTitle:String
    },
    components: {
        BImg,
        BLink,
        BButton,
    },
    data() {
        return {}
    }
}
</script>

<style lang="scss">

.plusButtoxn {
    background-color: transparent !important;
    position: fixed;
    border: 0;
    top:83%;
    right:1%;
    //border-radius:50%;
}

.preTitlse {
    position: fixed;
    top:85%;
    right:20%;
    color: #5E8F23;
    font-weight: 600;
    font-size: medium;
}
</style>